import { useEffect, useState } from "react";
import { Copy } from "lucide-react";
import { toast } from "sonner";
import { useServerStatus } from "@/lib/api";

export function ServerStatus() {
  const { data, isLoading } = useServerStatus();
  const online = data?.online;
  const pct = data?.max ? Math.min(100, (data.players / data.max) * 100) : 0;
  const copy = () => { navigator.clipboard?.writeText(`connect ${data.connect}`); toast.success("انسخ أمر الاتصال، الصقه في F8"); };
  return (
    <div className="glass w-full rounded-2xl p-5 sm:w-[340px]" data-testid="server-status">
      <div className="flex items-center justify-between">
        <span className="kicker !tracking-[0.2em]">SERVER STATUS</span>
        <span className="flex items-center gap-2 text-xs" data-testid="server-status-state">
          <i className={online ? "dot-live" : "dot-off"} />{isLoading ? "..." : online ? "متصل" : "غير متصل"}
        </span>
      </div>
      <div className="mt-4 flex items-end gap-2">
        <span className="font-mono2 text-4xl font-bold text-white" data-testid="server-status-players">{data?.players ?? 0}</span>
        <span className="pb-1 font-mono2 text-sm text-slate-500">/ {data?.max || 128}</span>
        <span className="pb-1.5 ps-1 text-xs text-slate-400">لاعب متصل</span>
      </div>
      <div className="mt-3 h-1.5 overflow-hidden rounded-full bg-slate-800">
        <div className="h-full rounded-full bg-gradient-to-l from-sky-300 to-cyan-500 shadow-[0_0_12px_#38bdf8] transition-[width] duration-700" style={{ width: `${pct}%` }} />
      </div>
      {data?.connect && (
        <button onClick={copy} className="mt-4 flex w-full items-center justify-between rounded-xl border border-sky-400/15 bg-black/30 px-3 py-2.5 font-mono2 text-xs text-sky-200 transition-colors hover:border-sky-400/50" data-testid="server-connect-copy">
          <span dir="ltr">connect {data.connect}</span><Copy size={14} />
        </button>
      )}
    </div>
  );
}

const pad = (n) => String(n).padStart(2, "0");

export function Countdown({ openAt }) {
  const target = openAt ? new Date(openAt).getTime() : 0;
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 1000); return () => clearInterval(t); }, []);
  const left = Math.max(0, target - now);
  if (!target || left === 0) {
    return <div className="font-disp text-2xl font-bold text-sky-300 sm:text-3xl" data-testid="countdown-open">المدينة مفتوحة الآن — تفضل وادخل</div>;
  }
  const parts = [["يوم", Math.floor(left / 864e5)], ["ساعة", Math.floor(left / 36e5) % 24], ["دقيقة", Math.floor(left / 6e4) % 60], ["ثانية", Math.floor(left / 1e3) % 60]];
  return (
    <div className="flex gap-3" data-testid="countdown">
      {parts.map(([l, v]) => (
        <div key={l} className="glass min-w-[72px] rounded-xl px-3 py-3 text-center">
          <div className="font-mono2 text-3xl font-bold text-white">{pad(v)}</div>
          <div className="mt-1 text-[11px] text-slate-400">{l}</div>
        </div>
      ))}
    </div>
  );
}
